import React, { useEffect, useState } from 'react';
import { Chip } from '@material-ui/core';
//import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import { pStatus} from "../../utils/parameters";
import { useVideo } from "../../api/VideoProvider";
import { useTranslation } from "react-i18next";

export function RecordingChip(props) {
    const { status } = props
    const { t } = useTranslation("global")

    const { faceStatus } = useVideo();
    const [label, setLabel] = useState("Cargando");

    function decipherWebcamStatus(status) {
        switch (status) {
            case "idle":
                return t("RecordingChip.status_idle")
            case "acquiring_media":
                return t("RecordingChip.status_acquiring_media")
            case "permission_denied":
                return t("RecordingChip.status_permission_denied")
            case "recording":
                return t("RecordingChip.status_recording")
            case "stopping":
                return t("RecordingChip.status_stopping")
            case "stopped":
                return t("RecordingChip.status_stopped")
            default:
                return "Error"
        }
    }

    useEffect(() => {
        /* 
        * Library 'bug':
        * If the user hits the repeat button, the video status is still 'stopped'
        * The right status should be 'idle'
        */
        if (status === 'stopped' && faceStatus !== pStatus.rep) {
            setLabel(t("RecordingChip.status_idle"))
        } else {
            setLabel(decipherWebcamStatus(status))
        }
    }, [status, faceStatus])

    return (
        <Chip
            className={`sig_Home_RecordingChip ${faceStatus === pStatus.record ? 'sig_Home_RecordingChipActive' : ''} ${faceStatus === pStatus.rep ? 'sig_Home_RecordingChipRepetition' : ''}`}
            label={label}
            size="medium" color="secondary"
            icon={faceStatus === pStatus.record === 'recording' ? <VideocamIcon /> : <VideocamOffIcon />}
        />

    )
}